module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAM5JREFUOE9jZKASYKSSOQzUNYgvd0cBAyND/CcmdkeGCY4fuAt2GTD//XfgLzOTw9cJbhdArubL3f7gLzNzAIyP7hO4i3jzti9gZGDUhxnGm7s9gZGBcQLMMIjhfzfgMgzFa5QYhhFG5BqGNbDJMQxnrMENm+RhCApYWJj9Yv5v8GOC5wP0MMNrEMN/RoPPkz0MyDYI5BqwIczsDqDkQEwMYg1sUg0BuRgj+skxBMUgcryDnLrBLgJlkf8MDAmwMKEoi1BaClA391PqGpB+AIV26hPHgKvQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/culture_icon.png
// module id = fqjF
// module chunks = 0